import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';

function classNames(...classes) {
  return classes.filter(Boolean).join(' ');
}

export default function DropDown({
  show,
  children,
  hide,
  togglerRef,
  useRel = false,
  dataTest = 'dropdown-component',
}) {
  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (togglerRef.current && togglerRef.current.contains(event.target)) {
        return;
      }

      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        hide();
      }
    }

    // Bind the event listener when dropdown is open
    if (show) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    // Cleanup listener on unmount or when dropdown closes
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [show]);

  return (
    <div
      data-test={dataTest}
      ref={dropdownRef}
      className={classNames(
        ' flex transform xl:w-[147.9px] overflow-visible flex-col items-center justify-center z-40  absolute  transition-all duration-500',
        !show
          ? 'p-0 max-h-0 invisible w-0 xl:w-[147.9px]  -translate-y-[5px] opacity-0 overflow-hidden'
          : ' p-2 visible translate-y-[0px] w-[147.9px] xl:w-[147.9px] opacity-100 max-h-[500px] ',
        useRel ? 'relative' : 'absolute',
      )}
    >
      {children}
    </div>
  );
}

DropDown.propTypes = {
  show: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired,
  hide: PropTypes.func.isRequired,
  togglerRef: PropTypes.object.isRequired,
  useRel: PropTypes.bool,
  dataTest: PropTypes.string,
};
